import AsyncStorage from '@react-native-async-storage/async-storage';
import config from '../config';
import { isAppearance, type AppearanceConfig } from './appearance';

// Scoped to the API deployment. Contains public tokens only; no account data.
export const APPEARANCE_CACHE_KEY = `app-appearance:v1:${config.apiGateway.endpoint}`;
export async function readAppearanceCache(): Promise<AppearanceConfig | null> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    const raw = await Promise.race([
      AsyncStorage.getItem(APPEARANCE_CACHE_KEY),
      new Promise<null>((resolve) => { timer = setTimeout(() => resolve(null), 750); }),
    ]);
    if (!raw) return null;
    const value: unknown = JSON.parse(raw);
    return isAppearance(value) ? value : null;
  } catch { return null; }
  finally { if (timer) clearTimeout(timer); }
}

// Never publishes to React: every network update is for the NEXT cold launch.
// Missing/invalid payloads retain the last good copy; explicit null is reset.
export async function stageAppearance(value: unknown): Promise<void> {
  if (!isAppearance(value)) return;
  try { await AsyncStorage.setItem(APPEARANCE_CACHE_KEY, JSON.stringify(value)); }
  catch { /* A full/unavailable disk must not interrupt care. */ }
}
